export const TEXT_ANSWER_CLASSIC = "ClassicTestAnswerVariantTextDto";
export const IMAGE_FROM_BANK_ANSWER_CLASSIC = "ClassicTestAnswerVariantImageBankDto";
export const IMAGE_FROM_UPLOAD_ANSWER_CLASSIC = "ClassicTestAnswerVariantImageQuestionDto";
export const FORMULA_ANSWER_CLASSIC = "ClassicTestAnswerVariantFormulaDto";
export const IMAGE_ANSWER_CLASSIC = "ClassicTestAnswerVariantImageQuestionDto";
export const AUDIO_ANSWER_CLASSIC = "ClassicTestAnswerVariantAudioDto";
